











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {FormatoArquivoRelatorio} from '@/model/resource/FormatoArquivoRelatorio'
import {FormatoArquivoRelatorioCollection} from '@/model/collection/FormatoArquivoRelatorioCollection'
import {ListFormatoArquivoRelatorioSchema} from '@/schema/resource/FormatoArquivoRelatorio/ListFormatoArquivoRelatorioSchema'
import {CsvFormatoArquivoRelatorioSchema} from '@/schema/resource/FormatoArquivoRelatorio/CsvFormatoArquivoRelatorioSchema'

@Component
export default class ListFormatoArquivoRelatorioView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListFormatoArquivoRelatorioSchema()
  collection = new FormatoArquivoRelatorioCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: FormatoArquivoRelatorio) {
    Helper.pushByName('editFormatoArquivoRelatorio', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new FormatoArquivoRelatorioCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvFormatoArquivoRelatorio()
    new CsvFormatoArquivoRelatorioSchema().downloadCsv(csv.all())
  }
}
